




















































































































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.use(VueApexCharts);

interface CommunitySite {
  id: string;
  name: string;
  township: string;
  population: number;
  measurementUsers: number;
  abnormal: number;
  followUp: number;
  followUpCompleted: number;
  activity: number;
}

interface VitalTrend {
  key: string;
  label: string;
  unit: string;
  color: string;
  data: number[];
}

@Component({
  components: {
    VueApexCharts,
  },
})
export default class CommunityOverview extends Vue {
  public selectedDateRange = "本月";
  public selectedCommunityId = "all";
  public attentionDialog = false;

  public dateRangeOptions = ["本月", "近 3 個月", "近 6 個月", "本年度"];

  // 社區人數（總人數）依實際規模控制在 20～40 人，平均約 30 人
  public communities: CommunitySite[] = [
    { id: "a", name: "斗六社區", township: "斗六市", population: 38, measurementUsers: 34, abnormal: 7, followUp: 3, followUpCompleted: 2, activity: 20 },
    { id: "b", name: "斗南社區", township: "斗南鎮", population: 34, measurementUsers: 30, abnormal: 8, followUp: 4, followUpCompleted: 2, activity: 18 },
    { id: "c", name: "虎尾社區", township: "虎尾鎮", population: 40, measurementUsers: 37, abnormal: 6, followUp: 2, followUpCompleted: 1, activity: 24 },
    { id: "d", name: "北港社區", township: "北港鎮", population: 28, measurementUsers: 25, abnormal: 5, followUp: 2, followUpCompleted: 1, activity: 14 },
    { id: "e", name: "古坑社區", township: "古坑鄉", population: 24, measurementUsers: 21, abnormal: 4, followUp: 1, followUpCompleted: 1, activity: 12 },
    { id: "f", name: "林內社區", township: "林內鄉", population: 20, measurementUsers: 18, abnormal: 3, followUp: 1, followUpCompleted: 1, activity: 10 },
  ];

  public trendMonths = ["2月", "3月", "4月", "5月", "6月", "7月"];

  public vitalTrends: VitalTrend[] = [
    { key: "bp", label: "血壓（收縮壓平均）", unit: "mmHg", color: "#d34b53", data: [130, 132, 129, 134, 136, 133] },
    { key: "hr", label: "心率平均", unit: "bpm", color: "#3979a4", data: [74, 75, 73, 76, 78, 75] },
    { key: "spo2", label: "血氧平均", unit: "%", color: "#0f9f79", data: [97, 97, 96, 98, 97, 97] },
    { key: "grip", label: "握力平均", unit: "kg", color: "#a97519", data: [23, 24, 22, 25, 24, 26] },
    { key: "bmi", label: "BMI 平均", unit: "kg/m²", color: "#775aa2", data: [24.1, 24.3, 24.0, 24.5, 24.6, 24.4] },
    { key: "glucose", label: "血糖平均", unit: "mg/dL", color: "#c9791f", data: [102, 105, 99, 108, 110, 104] },
  ];

  public processingStatusBreakdown = [
    { label: "待社區完成回報", count: 2 },
    { label: "待個管確認", count: 5 },
    { label: "處理中", count: 3 },
    { label: "已轉交專業人員", count: 1 },
    { label: "已完成", count: 2 },
  ];

  public waitingTimeBreakdown = [
    { label: "24 小時內", count: 4 },
    { label: "1 至 3 日", count: 6 },
    { label: "4 至 7 日", count: 2 },
    { label: "超過 7 日", count: 1 },
  ];

  public supportNotes = [
    "斗南社區：異常人數占量測使用人數比例較高（8／30），建議優先安排複測",
    "虎尾社區：後續關注人數等待處理時間較長，建議個管師優先確認",
  ];

  get communityOptions() {
    return [
      { text: `全部社區（${this.communities.length}）`, value: "all" },
      ...this.communities.map((site) => ({ text: site.name, value: site.id })),
    ];
  }

  get scopeCommunities(): CommunitySite[] {
    if (this.selectedCommunityId === "all") return this.communities;
    return this.communities.filter((site) => site.id === this.selectedCommunityId);
  }

  get scopeLabel(): string {
    if (this.selectedCommunityId === "all") return "全部社區總覽";
    const site = this.communities.find((s) => s.id === this.selectedCommunityId);
    return site ? `${site.name}（${site.township}）` : "全部社區總覽";
  }

  get totals() {
    return this.scopeCommunities.reduce(
      (acc, site) => {
        acc.measurementUsers += site.measurementUsers;
        acc.abnormal += site.abnormal;
        acc.followUp += site.followUp;
        acc.activity += site.activity;
        return acc;
      },
      { measurementUsers: 0, abnormal: 0, followUp: 0, activity: 0 }
    );
  }

  get kpiCards() {
    return [
      { label: "量測使用人數", value: this.totals.measurementUsers, icon: "mdi-heart-pulse" },
      { label: "異常人數", value: this.totals.abnormal, icon: "mdi-alert-circle-outline" },
      {
        label: "後續關注人數",
        value: this.totals.followUp,
        icon: "mdi-clipboard-alert-outline",
        clickable: true,
      },
      { label: "健康促進活動參與人數", value: this.totals.activity, icon: "mdi-run" },
    ];
  }

  get communityPieOptions() {
    return {
      chart: { toolbar: { show: false }, fontFamily: "inherit" },
      labels: this.scopeCommunities.map((site) => site.name),
      colors: ["#24b58b", "#3979a4", "#a97519", "#775aa2", "#d34b53", "#0f9f79"],
      legend: { position: "bottom" },
      dataLabels: {
        enabled: true,
        formatter: (_val: number, opts: TODO) =>
          `${opts.w.config.series[opts.seriesIndex]} 人`,
      },
      tooltip: {
        y: {
          formatter: (val: number) => `${val} 人`,
        },
      },
    };
  }

  get communityPieSeries() {
    return this.scopeCommunities.map((site) => site.measurementUsers);
  }

  public vitalChartOptions(trend: VitalTrend) {
    return {
      chart: { toolbar: { show: false }, fontFamily: "inherit" },
      xaxis: { categories: this.trendMonths },
      colors: [trend.color],
      stroke: { width: 3, curve: "smooth" },
      dataLabels: { enabled: false },
      legend: { show: false },
    };
  }

  public vitalChartSeries(trend: VitalTrend) {
    return [{ name: trend.label, data: trend.data }];
  }

  public attentionRatio(site: CommunitySite): string {
    if (site.measurementUsers === 0) return "0.0";
    return ((site.followUp / site.measurementUsers) * 100).toFixed(1);
  }

  public openAttentionDialog(): void {
    this.attentionDialog = true;
  }
}
